import _ from 'underscore';

export default class PricingBlock {
  amount: any;
  price: any;
  renewalAmount: any;
  unitLabel: string;
  productKey: any;
  rolePricing?: string;

  constructor(options: PricingBlock, product: PricingBlock) {
    Object.assign(this, options, _.pick(product, 'productKey', 'parentKey', 'productType', 'productDescription', 'parentDescription'));
    this.amount        = this.price;
    this.renewalAmount = this.price;
    this.unitLabel     = 'USER';

    switch(this.productKey) {
      case 'com.atlassian.servicedesk.ondemand':
      case 'jira-servicedesk.ondemand':
        this.unitLabel = 'AGENT';
        this.rolePricing = 'Per Service Desk agent';
        break;
      case 'com.atlassian.hipchat':
        this.rolePricing = 'Per Hipchat user';
        break;
    }
  }
}
